/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FareBasisCode
 */
export interface FareBasisCode {
    /**
     * 
     * @type {string}
     * @memberof FareBasisCode
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FareBasisCode
     */
    ticketDesignator?: string | null;
    /**
     * 
     * @type {object}
     * @memberof FareBasisCode
     */
    fareBreakPoint?: object;
}

export function FareBasisCodeFromJSON(json: any): FareBasisCode {
    return FareBasisCodeFromJSONTyped(json, false);
}

export function FareBasisCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareBasisCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'ticketDesignator': !exists(json, 'ticketDesignator') ? undefined : json['ticketDesignator'],
        'fareBreakPoint': !exists(json, 'fareBreakPoint') ? undefined : json['fareBreakPoint'],
    };
}

export function FareBasisCodeToJSON(value?: FareBasisCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'ticketDesignator': value.ticketDesignator,
        'fareBreakPoint': value.fareBreakPoint,
    };
}


